/**
 * Kosakata dasar pemrosesan — tipe untuk seluruh kode, DIBACA dari satu berkas.
 *
 * `privacy-vocabulary.json` adalah sumbernya. Berkas ini tidak menyalin satu pun
 * nilainya, dan gerbang `tools/ci/cek-dasar-pemrosesan.py` memeriksa bahwa ia
 * tidak menyalinnya: dua daftar yang sama-sama benar hari ini adalah dua daftar
 * yang berbeda tiga sprint kemudian, dan yang berbeda akan ditemukan di produksi
 * oleh permintaan pertama yang memakai nilai baru.
 *
 * Kosakata yang sama juga muncul sebagai CHECK constraint pada tabel `consent`,
 * dan gerbang itu membandingkan keduanya.
 */
import vocabulary from './privacy-vocabulary.json' with { type: 'json' };
export const LEGAL_BASES = Object.keys(vocabulary.legal_bases);
export const PROCESSING_PURPOSES = Object.keys(vocabulary.purposes);
export const CONSENT_PURPOSES = Object.keys(vocabulary.consent_purposes);
export const PROCESSING_CONTROLS = Object.keys(vocabulary.controls);
export const PROCESSING_SUBJECTS = Object.keys(vocabulary.subjects);
export const DATA_CATEGORIES = Object.keys(vocabulary.data_categories);
export const AGREEMENT_CLAUSES = Object.keys(vocabulary.agreement_clauses);
/** Pasal UU 27/2022 untuk satu dasar hukum — dipakai dokumen dan layar. */
export function articleOf(basis) {
    return vocabulary.legal_bases[basis].article;
}
/** Apa yang terjadi bila sebuah persetujuan ditarik. */
export function withdrawalEffectOf(purpose) {
    return vocabulary.consent_purposes[purpose].withdrawal_effect;
}
/**
 * Siapa yang menyatakan persetujuan ini.
 *
 * `SELF` = orangnya sendiri tentang dirinya. `THIRD_PARTY_NOTIFIED` = pernyataan
 * seseorang bahwa orang lain sudah diberi tahu — bukan persetujuan atas nama
 * orang lain, yang tidak mungkin ada.
 */
export function declaredBy(purpose) {
    return vocabulary.consent_purposes[purpose].declared_by;
}
/**
 * Jenis catatan: IZIN atau PENGAKUAN TELAH DIBERI TAHU.
 *
 * Bedanya bukan tata bahasa. Sebuah izin (Pasal 20(2)a) dapat ditarik dan
 * pemrosesannya berhenti; sebuah pengakuan (Pasal 21) tidak dapat ditarik karena ia
 * bukan izin — pemrosesannya berdiri di atas hubungan kerja yang ditetapkan
 * Pengendali, dan tidak pernah bergantung pada centangnya. Mencampur keduanya
 * menghasilkan catatan yang tidak dapat dipakai membuktikan apa pun.
 */
export function consentKind(purpose) {
    return vocabulary.consent_purposes[purpose].kind;
}
export function isLegalBasis(value) {
    return typeof value === 'string' && LEGAL_BASES.includes(value);
}
export function isConsentPurpose(value) {
    return typeof value === 'string' && CONSENT_PURPOSES.includes(value);
}
export { vocabulary as PRIVACY_VOCABULARY };
//# sourceMappingURL=privacy.js.map